<template>
  <div class="category-bar">
    <div class="top-part" @click="toggle()">
      <p class="title">{{ info.category_title }}</p>
      <a class="flex w-fit self-end hover:scale-95 transition" v-if="!info.has_sub_options" target="_blank" role="button" :href="`${info.spec_sheet.url}`" :download="`${info.category_title}`">
        <div class="cursor-pointer specs-button flex items-center border border-black rounded-full w-fit px-3 py-1">
          <p class="mr-2 text-[12px]">Specs</p><img src="@/assets/img/download-black.svg" alt="">
        </div>
      </a>
      <img class="cursor-pointer transition" :class="show ? 'rotate-180' : ''" v-if="info.has_sub_options" src="@/assets/img/drop-down-circle.svg" alt="">
    </div>
    <SlideUpDown v-model="show">
      <div v-if="info.has_sub_options" class="sub-content">
        <div class="sub-item" v-for="(sub, index) of info.sub_option" :key="index">
          <p class="sub-title">{{ sub.sub_option_title }}</p>
          <a class="flex w-fit self-end hover:scale-95 transition" v-if="sub.sub_option_spec" target="_blank" role="button" :href="`${sub.sub_option_spec.url}`" :download="`${sub.sub_option_title}`">
          <div class="cursor-pointer specs-button flex items-center border border-black rounded-full w-fit px-3 py-1">
            <p class="mr-2 text-[12px]">Specs</p><img src="@/assets/img/download-black.svg" alt="">
          </div>
        </a>
        </div>
      </div>
    </SlideUpDown>
  </div>
</template>
<script setup>
import { ref } from 'vue'
import SlideUpDown from 'vue3-slide-up-down'

const show = ref(false)
defineProps(['info'])

const toggle = () => {
  show.value = !show.value
}

</script>
<style lang="scss" scoped>
  .category-bar {
    @apply bg-white p-5 rounded-2xl mb-2 w-full flex flex-col;
    .top-part {
      @apply flex justify-between w-full;
      p.title {
        @apply text-ore_green text-2xl font-medium leading-10 font-FHOscar;
      }
    }
    .sub-content {
      @apply block pt-5;
      .sub-item {
        @apply flex justify-between py-5 border-t border-ore_green/20;
      }
    }
  }
</style>
